import { ReactNode, createContext } from "react";
import useCurso, { CursoType, CreateCursoType, EditCursoType } from "./hooks/useCurso";

interface CursoContextProviderProps {
    children: ReactNode;
}

export interface CursoContextData {
    createCurso: (createCursoData: CreateCursoType) => Promise<CreateCursoType | null>;
    getCursoPaged: (
        pageNumber: number,
        Name?: string,
        EmpresaId?: number,
        pageSize?: number
    ) => Promise<CursoType[] | null>;
    updateCurso: (editCursoData: EditCursoType) => Promise<EditCursoType | null>;
    deleteCurso: (cursoId: number) => Promise<CursoType | null>;
    handleGetCursoById: (cursoId: number) => Promise<CursoType | null>;
    setCurso: any;
    curso: CursoType;
    listCurso: CursoType[];
    initialListCurso: CursoType[];
    setListCurso: (curso: CursoType[]) => void;
    setPageCount: (count: number) => void;
    pageCount: number;
    handleGetCursoByEmpresaId: (empresaId: number) => Promise<CursoType[] | null>;
    handleGetCursoByContratoId: (contratoId: number) => Promise<CursoType[] | null>;
    listCursoByContrato: CursoType[];
    setListCursoByContrato: (curso: CursoType[]) => void;
}

const initialState: CursoContextData = {
    createCurso: async () => null,
    getCursoPaged: async () => null,
    updateCurso: async () => null,
    deleteCurso: async () => null,
    handleGetCursoById: async () => null,
    setCurso: () => {},
    curso: {
        id: 0,
        name: "",
    },
    listCurso: [],
    initialListCurso: [],
    setListCurso: () => {},
    setPageCount: () => {},
    pageCount: 0,
    handleGetCursoByEmpresaId: async () => null,
    handleGetCursoByContratoId: async () => null,
    listCursoByContrato: [],
    setListCursoByContrato: () => {},
};

export const CursoContext =
    createContext<CursoContextData>(initialState);

export default function CursoContextProvider({
    children,
}: CursoContextProviderProps) {
    const {
        createCurso,
        getCursoPaged,
        updateCurso,
        deleteCurso,
        handleGetCursoById,
        setCurso,
        curso,
        listCurso,
        initialListCurso,
        setListCurso,
        pageCount,
        setPageCount,
        handleGetCursoByEmpresaId,
        handleGetCursoByContratoId,
        listCursoByContrato,
        setListCursoByContrato,
    } = useCurso();

    return (
        <CursoContext.Provider
            value={{
                createCurso,
                getCursoPaged,
                updateCurso,
                deleteCurso,
                handleGetCursoById,
                setCurso,
                curso,
                listCurso,
                initialListCurso,
                setListCurso,
                setPageCount,
                pageCount,
                handleGetCursoByEmpresaId,
                handleGetCursoByContratoId,
                listCursoByContrato,
                setListCursoByContrato,
            }}
        >
            {children}
        </CursoContext.Provider>
    );
}
